import { HttpResponse, HttpResponseList } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponseLotsManagement } from 'shell/models/lots-management';
import {
  TableLotsManagementVM,
  BodyLotsManagementVM,
} from 'front-office/view-models/lots-management/list';
import { DateTime } from 'luxon';
import { LotsManagementEditVM } from 'front-office/view-models/lots-management/edit';

export const transformerLotsManagementDataList = (
  response: AxiosResponse<HttpResponseList<ResponseLotsManagement>>
): TableLotsManagementVM => {
  const data = response.data?.payload?.list || [];

  const list: Array<BodyLotsManagementVM> = data.map((item) => {
    const hours = item.key?.oraAssegnazione
      ? DateTime.fromFormat(item.key?.oraAssegnazione, 'HHmmss').toFormat('HH.mm.ss')
      : '';

    const date = item.key?.dataAssegnazione
      ? DateTime.fromISO(item.key?.dataAssegnazione).toFormat('dd/MM/yyyy')
      : '';

    const startLots = item.numeroInizioLotto ? item.numeroInizioLotto.substring(1) : '';

    const endLots = item.numeroFineLotto ? item.numeroFineLotto.substring(1) : '';

    return {
      service: item.key?.servizio || '',
      operator: item.key?.operatore || '',
      dateTimeAssignment: `${date} ${hours}`,
      startLots,
      endLots,
      cardsLots: item.numeroRilasciate?.toString() || '',
    };
  });

  return {
    list,
  };
};

export const transformerLotsManagementDataEdit = (
  response: AxiosResponse<HttpResponse<ResponseLotsManagement>>
): LotsManagementEditVM => {
  const data = response.data?.payload || {};

  const fromNumber = data.numeroInizioLotto ? data.numeroInizioLotto.substring(1) : '';

  const toNumber = data.numeroFineLotto ? data.numeroFineLotto.substring(1) : '';

  const responseFormatted: LotsManagementEditVM = {
    service: data.key?.servizio || '',
    operator: data.key?.operatore || '',
    isRectificationCards: true,
    fromNumber,
    toNumber,
    released: data.numeroRilasciate || 0,
    oldFromNumber: data.numeroInizioLotto || '',
    oldToNumber: data.numeroFineLotto || '',
  };

  return responseFormatted;
};
